export const clock = {
  viewBox: "0 0 512 512",
  path: <></>,
};

export const idea = {
  viewBox: "0 0 1024 1024",
  path: (
    <>
      <path d="M512 256c-125.155556 0-227.555556 102.4-227.555556 227.555556 0 51.2 17.066667 96.711111 45.511112 133.688888 0 0 8.533333 11.377778 11.377777 14.222223 25.6 31.288889 88.177778 119.466667 88.177778 193.422222h170.666667c0-73.955556 62.577778-162.133333 88.177778-193.422222 2.844444-2.844444 11.377778-14.222222 11.377777-14.222223 28.444444-36.977778 45.511111-85.333333 45.511111-133.688888-5.688889-125.155556-108.088889-227.555556-233.244444-227.555556zM426.666667 881.777778h170.666666v113.777778h-170.666666zM56.888889 455.111111h170.666667v56.888889H56.888889zM796.444444 455.111111h170.666667v56.888889h-170.666667zM813.994667 141.624889l40.220444 40.220444-120.661333 120.689778-40.220445-40.220444zM483.555556 28.444444h56.888888v170.666667h-56.888888zM210.289778 141.312l120.689778 120.689778-40.220445 40.220444-120.689778-120.661333z" />
    </>
  ),
};

export const DefaultIcon = {
  viewBox: "0 0 0 0",
  path: (
    <>
      <path d="M 0 0" />
    </>
  ),
};
